@if (content(); as content) {
    <div class="container-fluid">
        @if (content.Title && (content.ContentType == 0 || content.ContentType == 2)) {
            <div class="page-header row">
                <h1>{{ content.Title }}</h1>
            </div>
        }
        @if (content.Username && content.PublishDate && (content.ContentType == 0 || content.ContentType == 2)) {
            <p>
                <i>Written by: {{ content.Username }} - {{ content.PublishDate | date: "M/d/yy '-' h:mm a" }}</i>
            </p>
        }
        @if (contentInnerHtml(); as contentInnerHtml) {
            <div [innerHtml]="contentInnerHtml"></div>
        }
    </div>
}
